import { render, staticRenderFns } from "./IntellectualProperty.vue?vue&type=template&id=f1e38256&scoped=true"
import script from "./IntellectualProperty.vue?vue&type=script&lang=js"
export * from "./IntellectualProperty.vue?vue&type=script&lang=js"
import style0 from "./IntellectualProperty.vue?vue&type=style&index=0&id=f1e38256&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e38256",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1e38256')) {
      api.createRecord('f1e38256', component.options)
    } else {
      api.reload('f1e38256', component.options)
    }
    module.hot.accept("./IntellectualProperty.vue?vue&type=template&id=f1e38256&scoped=true", function () {
      api.rerender('f1e38256', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customize/Front/IDL/IntellectualProperty.vue"
export default component.exports